var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 7.67046C14.7 7.13864 14.6523 6.62728 14.5636 6.13637H7.5V9.04091H11.5364C11.3591 9.975 10.8273 10.7659 10.0295 11.2977V13.1864H12.4636C13.8818 11.8773 14.7 9.95455 14.7 7.67046Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50014 15.0003C9.52514 15.0003 11.2229 14.3321 12.4638 13.1867L10.0297 11.298C9.36151 11.748 8.50923 12.0208 7.50014 12.0208C5.55014 12.0208 3.89332 10.7049 3.30014 8.93213H0.804688V10.8685C2.03878 13.3162 4.56832 15.0003 7.50014 15.0003Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 8.92446C3.15 8.47446 3.06136 7.99718 3.06136 7.49946C3.06136 7.00173 3.15 6.52446 3.3 6.07446V4.13809H0.804546C0.293182 5.14718 0 6.28582 0 7.49946C0 8.71309 0.293182 9.85173 0.804546 10.8608L2.74773 9.34718L3.3 8.92446Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50014 2.98636C8.60469 2.98636 9.5865 3.36818 10.3706 4.10455L12.5183 1.95682C11.2161 0.743182 9.52514 0 7.50014 0C4.56832 0 2.03878 1.68409 0.804688 4.13864L3.30014 6.075C3.89332 4.30227 5.55014 2.98636 7.50014 2.98636Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.c2417bc1.svg";
export { ForwardRef as ReactComponent };